import Hotjar from '@hotjar/browser'

const domainMap = {
    'disappearing-lighter.com': '5341721',
    'disappearing-lighters.com': '5341722',
    'lost-lighter.com': '5341723',
    'lost-lighters.com': '5341724',
    'lighter-coin.com': '5341725',
}

const siteId = domainMap[window.location.hostname]
const hotjarVersion = 6

Hotjar.init(siteId, hotjarVersion)